import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_3w8zchvgxk: FaireBrandEntity = {
  token: "b_3w8zchvgxk",
  type: "brand",
  name: "Jasey's Toy Chest",
  avatarUrl:
    "https://cdn.faire.com/fastly/74697f62b1469e2ec4784261b47c9dbabaabdb5715e7681452ce583c76ca1d79.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f8e051e4a049d254173de1745c49d6a6d923fc1c681eb6b76c1056fe9fe58102.png",
  logoUrl:
    "https://cdn.faire.com/fastly/74697f62b1469e2ec4784261b47c9dbabaabdb5715e7681452ce583c76ca1d79.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f8e051e4a049d254173de1745c49d6a6d923fc1c681eb6b76c1056fe9fe58102.png",
  location: "Westport, CT, USA",
  minimumOrderDollars: 150,
  rating: 0,
  reviewCount: 0,
  isInsider: true,
  description:
    "At Jasey’s Toy Chest, we believe in the power of magical moments – the kind that blossom through open-ended play, joyful learning, and heartfelt connection. This brand was created in loving memory of our son Jason (“Jasey”), who filled our home with creativity, adventure, and immense joy. His toy chest was a daily treasure hunt – every morning, he’d pull out blocks, puzzles, musical instruments, costumes, and dinosaurs, creating magical worlds of his own making. Our toys are a tribute to those memories and to the simple, magical moments that shape childhood. We’re also committed to supporting youth mental health – a cause deeply personal to our family. Drawing on decades of toy-industry experience, we craft toys designed to build skills, nurture confidence, encourage connection, and create lasting memories.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:19.438Z",
    importedBy: "entity-db-cli",
  },
};
